// extracted by mini-css-extract-plugin
export default {"root":"DefaultPaymentForm_root__bEDEu","empty":"DefaultPaymentForm_empty__WgKXM","payment-description":"DefaultPaymentForm_payment-description__9-gTD"};